module.exports = __webpack_public_path__ + "img/ararat-reg-logo-mobile.32b6288e.png";